import { SxProps } from '@mui/system'

export * from './AppThemeProvider'
export * from './ArtistThemeProvider'
export * from './StyleProvider'
import { config } from '@/config'

const {
  theme: { dark },
} = config

export const styles = {
  safeAreaTop: 'env(safe-area-inset-top, 0)',
  safeAreaBottom: 'env(safe-area-inset-bottom, 0)',
  negativeSafeAreaTop: 'calc(-1 * env(safe-area-inset-top, 0))',
}

export const styleSets = {
  /**
   * 指定した要素いっぱいに画像を表示し、下部から上方向へ背景色のグラデーションをかけるスタイル（バナー等で使用）
   * @param src 表示する画像URL
   * @param start グラデーションの始点が上から何%の位置にあるか。
   * @param bgcolor background color
   */
  backgroundImageWithGradient: (
    src?: string | null,
    start = 0,
    bgcolor?: string | null
  ) => ({
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundImage: `linear-gradient(to bottom, rgba(${
      dark ? '0,0,0' : '255,255,255'
    },0) ${start}%, ${
      bgcolor ? bgcolor : dark ? '#121212' : '#ffffff'
    } 100%), url("${src ?? ''}")`,
  }),
  /**
   * Render an ellipsis "..." to represent the clipped text
   * @param lines number of lines
   */
  lineCamp: (lines: number): SxProps => {
    if (lines === 1) {
      return {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }
    }
    return {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: '-webkit-box',
      // allows limiting of the contents of a block container to the specified number of lines
      // -Although it is a webkit prefix, it works with chrome etc. because it is implemented with the same name in rendering engines other than safari.
      WebkitLineClamp: `${lines}`,
      WebkitBoxOrient: 'vertical',
      whiteSpace: 'normal',
    } as SxProps
  },
  // portrait phones, less than 375px
  extraExtraSmallMedia(sx: SxProps) {
    return {
      '@media only screen and (max-width: 375px)': sx,
    } as SxProps
  },
  /**
   * 横幅いっぱいに表示する背景画像の高さを返す
   * GlobalHome等で用いる
   * @param ratio 画像の縦横比
   */
  bgImageHeight(ratio: number | null) {
    return {
      xs: `calc(100vw * ${ratio ?? 1})`,
      sm: `calc(600px * ${ratio ?? 1})`,
    }
  },
  /**
   * 縦横のスクロールバーを非表示にする
   */
  hideScrollbar(): SxProps {
    return {
      scrollbarWidth: 'none',
      '::-webkit-scrollbar': {
        height: 0,
        width: 0,
        display: 'none',
        MozAppearance: 'none',
        WebkitAppearance: 'none',
      },
    } as SxProps
  },
}
